export class MessageModle {
  subject: string;
  message: string;
  via: string;

  constructor() {}
}
